import { render, staticRenderFns } from "./ShowAbilities.vue?vue&type=template&id=0fca8486&scoped=true"
import script from "./ShowAbilities.vue?vue&type=script&lang=js"
export * from "./ShowAbilities.vue?vue&type=script&lang=js"
import style0 from "./ShowAbilities.vue?vue&type=style&index=0&id=0fca8486&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca8486",
  null
  
)

export default component.exports